import { ChatSystemMessage } from '@agent/agent-interface/contact-view/chat/model/chat-system-message';
import { ChatEmojiService } from '@agent/agent-interface/contact-view/chat/services/chat-emoji.service';
import { ChatMessageUtilService } from '@agent/agent-interface/contact-view/chat/services/chat-message-util.service';
import { Component, Input, OnInit } from '@angular/core';

import { CustomerFacade, ProfileService, UntilDestroy } from '@contact/upgrade';

@UntilDestroy()
@Component({
  selector: 'chat-message-preview',
  templateUrl: 'chat-message-preview.component.html',
  styleUrls: ['./chat-message-preview.component.scss'],
})
export class ChatMessagePreviewComponent implements OnInit {
  @Input()
  public msges: ChatSystemMessage[];

  @Input()
  public customerCardId: string;

  public hasPreviewPermission: boolean;

  private firstName: String;

  ngOnInit() {
    this.hasPreviewPermission = this.profileService.hasPermission('CSR_CHAT_INCOMING::contact:preview');
    this.customerFacade.getById(this.customerCardId).subscribe(customer => {
      if (customer) {
        this.firstName = customer.firstname;
      }
    });
  }

  constructor(
    public emojiService: ChatEmojiService,
    private readonly chatMessageUtilService: ChatMessageUtilService,
    private readonly customerFacade: CustomerFacade,
    private readonly profileService: ProfileService
  ) {}

  getMessageContent(message: string): string {
    let text = this.chatMessageUtilService.processContent(message);
    return this.emojiService.emojify(text);
  }
}
